// Wedding color palette — dress code inspiration
export const PALETTE = {
  primary: [
    { hex: "#000000", note: "core" },
    { hex: "#FFFFFF", note: "prohibited", prohibited: true },
    { hex: "#FF8200", note: "core" },
    { hex: "#FA008A", note: "core" },
  ],
  secondary: [
    { hex: "#FF5400" },
    { hex: "#FF7300" },
    { hex: "#FF9E00" },
    { hex: "#FFC300" },
    { hex: "#FFEA00" },
    { hex: "#FC2F00" },
    { hex: "#F11D1D" },
    { hex: "#FF006E" },
    { hex: "#FF0054" },
    { hex: "#BF216D" },
  ],
  accent: [
    { hex: "#8C5230" },
    { hex: "#A66B37" },
    { hex: "#DDB892" },
    { hex: "#E6CCB2" },
    { hex: "#588157" },
    { hex: "#8CB369" },
    { hex: "#B5C99A" },
    { hex: "#CFE1B9" },
  ],
};
